import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useHasMenu } from '../../../auth/access';
import { SectionTitle } from '../../shared/components';
import HolidaysTab from '../components/setup/HolidaysTab';

/** HR → Holidays: the holiday calendar attendance and payroll read. Editing is the menu's EDIT action. */
export default function HolidaysPage() {
  const holidaysEdit = useHasMenu('hr.holidays', 'EDIT');
  const rulesEdit = useHasMenu('payroll.rules', 'EDIT');
  const canEdit = holidaysEdit || rulesEdit;
  return (
    <Stack gap={3}>
      <SectionTitle title='HOLIDAYS' />
      {!canEdit && <Alert severity='info'>Read only — your role can view the holidays but not change them.</Alert>}
      <HolidaysTab canEdit={canEdit} />
    </Stack>
  );
}
